import Hero from "../components/Hero";
import TechMarquee from "../components/TechMarquee";
import ServicesSection from "../components/ServicesSection";
import Products from "../components/Products";
import Projects from "../components/Projects";
import Contact from "../components/Contact";

function HomePage() {
  return (
    <>
      <Hero />
      <TechMarquee />
      <ServicesSection />
      <Products />
      <Contact />
    </>
  );
}

export default HomePage;
